// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getIncompleteList = createAsyncThunk(
  'incompleteProfile/getIncompleteList',
  async (params) => {
    const response = await axios.get(baseUrl() + '/dashboard/incomplete', { params })

    return {
      totalPages: response.data.count.total,
      params: response.data.params,
      data: response.data.data,
      loader: false
    }
  }
)


export const addTask = createAsyncThunk(
  'incompleteProfile/addTask',
  async (incompleteProfile, { dispatch }) => {
    try {
      let message = ''
      let status = ''
      await axios
        .post(baseUrl() + '/tasks', incompleteProfile, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          message = res?.data?.message
          status = 'success'
        })
        .catch((err) => {
          message = err?.response?.data?.message
          status = 'error'
        })

      return { message, status }
      //await dispatch(getIncompleteList())
      // return incompleteProfile
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return incompleteProfile
    }
  }
)

export const updateTask = createAsyncThunk(
  'incompleteProfile/updateTask',
  async ({ id, formData }) => {
    try {
      let message = ''
      let status = ''
      await axios
        .put(baseUrl() + `/tasks/${id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          message = res?.data?.message
          status = 'success'
        })
        .catch((err) => {
          message = err?.response?.data?.message
          status = 'error'
        })
      return { message, status }
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    }
  }
)


export const deleteTask = createAsyncThunk(
  'incompleteProfile/deleteTask',
  async ({ id }, { dispatch }) => {
    try {
      dispatch(setLoader())
      await axios.delete(baseUrl() + `/tasks/${id}`),
        toast.success('Task Deleted successfully')
      await dispatch(getIncompleteList())
      return id
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
)

export const incompleteProfile = createSlice({
  name: 'incompleteProfile',
  initialState: {
    companyList: [],
    selectProfile: [],
    reload: false,
    loader: true,
    taskStatus: {},
    totalPages: 0
  },
  reducers: {
    selectProfile: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    },
    setLoader: (state) => {
      state.loader = !state.loader
    }
  },

  extraReducers: {
    [addTask.fulfilled]: (state, action) => {
      state.reload = !state.reload
      state.taskStatus = action.payload
    },
    [getIncompleteList.fulfilled]: (state, action) => {
      ; (state.companyList = action.payload.data),
        (state.totalPages = action.payload.totalPages)
      state.loader = action.payload.loader
    },

    [updateTask.fulfilled]: (state, action) => {
      state.reload = !state.reload
      state.taskStatus = action.payload
    },

    [deleteTask.fulfilled]: (state, action) => {
      state.reload = !state.reload
    }
  }
})

export const { selectProfile, setLoader } = incompleteProfile.actions

export default incompleteProfile.reducer
